import { c as _c } from "react/compiler-runtime";
import CardAvatar from "@/components/cardElements/CardAvatar";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { User } from "@/types/me";
import { RealEstateAgency } from "@/types/real-estate";
import { useTranslations } from "next-intl";
import { AgencyContactRows } from "./AgencyContactRows";
import Link from "next/link";
import { ROUTE_PATHS } from "@/constants/routes";
import { buildUserProfileSlug } from "@/components/modules/user/public-profile/userProfileSlug";
import { useModal } from "@/components/providers/modal-provider/ModalProvider";
import { Rating } from "@/components/atoms/rating/Rating";
type RealEstateAgencyCardRoomRentProps = {
  user: User;
  hasContacts?: boolean;
  phones?: string[];
  title: string;
  url?: string;
  reference?: string | null;
  referenceUrl?: string | null;
  handleCopy: (value: string) => void;
  agency: RealEstateAgency;
  isOwner?: boolean;
  handleSendMessage?: () => void;
  hideMessageButton?: boolean;
};
export function RealEstateAgencyCardRoomRent(t0) {
  const $ = _c(45);
  const {
    user,
    hasContacts,
    phones,
    title,
    url,
    reference,
    referenceUrl,
    handleCopy,
    agency,
    isOwner,
    handleSendMessage,
    hideMessageButton
  } = t0;
  const tRealEstateDetail = useTranslations("modules.realEstateDetail");
  const {
    closeModal
  } = useModal();
  if (!user) {
    return null;
  }
  const email = agency?.email || (user?.showContacts !== false ? user?.email : undefined);
  let t1;
  if ($[0] !== user.id || $[1] !== user.name) {
    t1 = user.id ? ROUTE_PATHS.USER_PROFILE(buildUserProfileSlug({
      id: user.id,
      name: user.name ?? ""
    })) : null;
    $[0] = user.id;
    $[1] = user.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const profileHref = t1;
  const t2 = user?.image || "";
  const t3 = user?.name;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <CardAvatar imgUrl={t2} name={t3} className="w-16 h-16 border border-border shadow-md shrink-0" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const avatar = t4;
  let t5;
  if ($[6] !== user.name) {
    t5 = <span className="font-semibold text-base text-foreground-heading truncate">{user.name}</span>;
    $[6] = user.name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const name = t5;
  let t6;
  if ($[8] !== avatar || $[9] !== closeModal || $[10] !== profileHref) {
    t6 = profileHref ? <Link href={profileHref} onClick={() => closeModal()} className="shrink-0 cursor-pointer group">{avatar}</Link> : avatar;
    $[8] = avatar;
    $[9] = closeModal;
    $[10] = profileHref;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== closeModal || $[13] !== name || $[14] !== profileHref) {
    t7 = profileHref ? <Link href={profileHref} onClick={() => closeModal()} className="hover:underline truncate">{name}</Link> : name;
    $[12] = closeModal;
    $[13] = name;
    $[14] = profileHref;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== tRealEstateDetail || $[17] !== user.rating || $[18] !== user.reviewCount) {
    t8 = user.rating != null ? <Rating rating={user.rating} reviewCount={user.reviewCount} /> : <span className="text-xs text-faint-foreground">{tRealEstateDetail("noReviewsYet")}</span>;
    $[16] = tRealEstateDetail;
    $[17] = user.rating;
    $[18] = user.reviewCount;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <div className="flex flex-col min-w-0 flex-1 gap-1">{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== handleSendMessage || $[24] !== hideMessageButton || $[25] !== isOwner || $[26] !== tRealEstateDetail) {
    t10 = !isOwner && !hideMessageButton && <Button variant="simpleDark" size="md" onClick={handleSendMessage} className="self-center shrink-0 rounded-full px-5">{tRealEstateDetail("message")}</Button>;
    $[23] = handleSendMessage;
    $[24] = hideMessageButton;
    $[25] = isOwner;
    $[26] = tRealEstateDetail;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t6 || $[30] !== t9) {
    t11 = <div className="flex items-center gap-4 min-w-0">{t6}{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t6;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== email || $[33] !== handleCopy || $[34] !== hasContacts || $[35] !== phones || $[36] !== reference || $[37] !== referenceUrl || $[38] !== title || $[39] !== url || $[40] !== user.website) {
    t12 = (hasContacts && (phones?.length || email) || reference || user.website) && <><Separator /><AgencyContactRows phones={hasContacts ? phones : undefined} email={hasContacts ? email : undefined} website={user.website} reference={reference} referenceUrl={referenceUrl} title={title} url={url} handleCopy={handleCopy} /></>;
    $[32] = email;
    $[33] = handleCopy;
    $[34] = hasContacts;
    $[35] = phones;
    $[36] = reference;
    $[37] = referenceUrl;
    $[38] = title;
    $[39] = url;
    $[40] = user.website;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t11 || $[43] !== t12) {
    t13 = <Card className="bg-card" data-sentry-element="Card" data-sentry-component="RealEstateAgencyCardRoomRent" data-sentry-source-file="RealEstateAgencyCardRoomRent.tsx"><CardContent className="flex flex-col gap-3 p-5" data-sentry-element="CardContent" data-sentry-source-file="RealEstateAgencyCardRoomRent.tsx">{t11}{t12}</CardContent></Card>;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
}